import api from 'base/utils/api';
import { IAddAddress, IData, IResultsData } from '@pro/activity/testerClub/interface';
import type { GetServerSidePropsContext } from 'next';
import { getStoreState } from 'base/store'
import { RouteEnum } from 'pro/config/routers'
import { generatePath } from 'ava-util/dist/request';
import nextCookies from 'next-cookies';
import { COOKIE_LOGIN_TOKEN } from 'base/config/constant';

// 获取试用配置
export async function getEarlyAccessConfig(): Promise<IData> {
    return api.get('/web/activity/early-access/config')
}

// 参与活动
export async function participateTrial(params: {
    activityGid: number | string;
}): Promise<any> {
    return api.post('/web/activity/early-access/participate', {
        data: params
    })
}

// 添加用户地址
export async function addAddress(params: IAddAddress): Promise<any> {
    return api.post('/web/activity/early-access/addAddress', {
        data: params
    })
}

// 查看试用活动结果
export async function getEarlyAccessResults(params: {
    activityGid: string;
}): Promise<IResultsData> {
    return api.get('/web/activity/early-access/viewResult', {
        params: params
    })
}


export async function getServerSideProps({ query }: GetServerSidePropsContext) {
    const { ua: { isPhone } } = getStoreState('rootStore');

    const { activityId } = query

    if (isPhone && !!activityId) {
        // 手机端跳转结果页面
        return {
            redirect: {
                destination: generatePath(RouteEnum.TesterClubResults, { activityId: activityId }),
                permanent: false // 可选，是否永久重定向，默认为false
            }
        }
    }

    try {
        const serverProps = await getEarlyAccessConfig();

        return {
            props: { serverProps }
        }
    } catch (e) {
        return { props: { error: JSON.parse(JSON.stringify(e)) } }
    }
}

export async function getResultsServerSideProps(ctx: GetServerSidePropsContext) {
    const cookies = nextCookies(ctx);
    if(!cookies[COOKIE_LOGIN_TOKEN]) {
        return {
            redirect: {
                permanent: false,
                destination: generatePath(RouteEnum.LOGIN, { redirect: ctx.resolvedUrl || '/' }),
            },
        };
    }

    const { activityId } = ctx.query

    try {
        const serverProps = await getEarlyAccessResults({
            activityGid: activityId as string
        });

        return {
            props: { serverProps }
        }
    } catch (e) {
        /*return {
            notFound: true,
        }*/
        return { props: { error: JSON.parse(JSON.stringify(e)) } }
    }
}